import React, { useEffect, useState } from "react";
import DefaultHeader from "../../container/default-layout/header";
import DefaultSideBar from "../../container/default-layout/side.bar";
import { DefaultFooter } from "../../container/default-layout/footer";
import Loader from "../../../components/loader";
import CoachingSummaryService from "../../../services/CoachingSummaryService";
import auth from "../../../services/auth";

const CoachingDebriefSummaries = () => {
  const [loading, setLoading] = useState(true);
  const [summaries, setSummaries] = useState([]);
  const user = auth.getUserDetails();

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const accountIds = user?.accounts?.map((a) => a.accId) || [user?.accId];
        const response = await CoachingSummaryService().getSummaries(
          accountIds.filter(Boolean),
          []
        );
        setSummaries(response?.data || []);
      } catch (e) {
        console.error("Failed to load coaching summaries", e);
      }
      setLoading(false);
    };
    load();
  }, []);

  return (
    <>
      <DefaultHeader />
      <div className="page-content">
        <DefaultSideBar />
        <div className="content-inner">
          <section className="dashboard-header">
            <h2>Coaching Debrief Summaries</h2>
          </section>
          {loading ? (
            <Loader />
          ) : summaries.length === 0 ? (
            <p>No coaching debrief summaries found.</p>
          ) : (
            <div className="card">
              <div className="card-body">
                {summaries.map((summary) => (
                  <div key={summary.id} className="mb-4 pb-3 border-bottom">
                    <h4>
                      {summary.participantFirstName} {summary.participantLastName}{" "}
                      <small className="text-muted">({summary.participantEmail})</small>
                    </h4>
                    <p>
                      <strong>Golden Nugget:</strong> {summary.goldenNugget}
                    </p>
                    <p>
                      <strong>Frame Shift:</strong> {summary.frameShift}
                    </p>
                    <p>
                      <strong>Performance Wins:</strong>
                    </p>
                    <ul>
                      <li>{summary.performanceWin1}</li>
                      <li>{summary.performanceWin2}</li>
                    </ul>
                    <p>
                      <strong>System Change:</strong> {summary.actionPlanSystemChange}
                    </p>
                    <p>
                      <strong>Communication Shift:</strong>{" "}
                      {summary.actionPlanCommunicationShift}
                    </p>
                    <p>
                      <strong>Personal Growth:</strong> {summary.actionPlanPersonalGrowth}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      <DefaultFooter />
    </>
  );
};

export default CoachingDebriefSummaries;
